import Session from './session-manager.js';
import { addData } from './data-collection.js';
import { version } from './version.js';
const BASE_URL = 'https://analytics.data.visenze.com/v3';
const BASE_URL_CN = 'https://analytics.visenze.com.cn/v3';
const SDK = 'tracking js sdk';
const SDK_VERSION = version;
const TIMEOUT = 15000;
/**
 * @internal
 */
function _timeout(ms, promise) {
    const to = new Promise((_, reject) => setTimeout(() => reject(Error(`Timed out in ${ms} ms`)), ms));
    return Promise.race([to, promise]);
}
/**
 * @internal
 */
const _sendRequest = (fetchObj, callback, failure) => {
    return _timeout(TIMEOUT, fetchObj)
        .then((response) => {
        const status = response.status;
        if (status === 200) {
            return 'success';
        }
        else {
            const res = response.json();
            return res;
        }
    })
        .then((res) => {
        if (res === 'success') {
            if (callback) {
                callback();
            }
        }
        else {
            if (failure) {
                failure(res);
            }
        }
    })
        .catch((ex) => {
        if (failure) {
            failure(ex);
        }
    });
};
/**
 * @internal
 */
const _sendGetRequest = (path, params, callback, failure) => {
    const url = new URL(path);
    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.append(key, value);
    });
    const fetchObj = fetch(url, {
        method: 'GET',
    });
    return _sendRequest(fetchObj, callback, failure);
};
export default function Tracker(configs) {
    const code = configs.code;
    const sessionManager = Session(configs.uid);
    const isCN = !!configs.isCN;
    const endpoint = configs.endpoint;
    let baseUrl;
    if (endpoint) {
        baseUrl = endpoint;
    }
    else if (isCN) {
        baseUrl = BASE_URL_CN;
    }
    else {
        baseUrl = BASE_URL;
    }
    const client = {
        getUID() {
            return sessionManager.getUID();
        },
        setUID(uid) {
            sessionManager.setUID(uid);
        },
        getSID() {
            return sessionManager.getSID();
        },
        resetSession() {
            return sessionManager.resetSession();
        },
        getSessionTimeRemaining() {
            return sessionManager.getSessionTimeRemaining();
        },
        generateUUID() {
            return sessionManager.generateUUID();
        },
        validateEvents(events, failCallback) {
            if (!Array.isArray(events)) {
                failCallback === null || failCallback === void 0 ? void 0 : failCallback(Error('events must be an array'));
                return false;
            }
            if (events.length <= 0) {
                failCallback === null || failCallback === void 0 ? void 0 : failCallback(Error('events must have at least 1 item'));
                return false;
            }
            return true;
        },
        sendEvent(action, event, successCallback, failCallback) {
            const path = `${baseUrl}/__va.gif`;
            const defaultParams = this.getDefaultTrackingParams(action);
            const params = addData(defaultParams, event);
            void _sendGetRequest(path, params, successCallback, failCallback);
        },
        sendEvents(action, events, successCallback, failCallback) {
            if (!this.validateEvents(events, failCallback)) {
                return;
            }
            const batchId = sessionManager.generateUUID();
            events.forEach((event) => {
                if (action.toLowerCase() === 'transaction' && !event['transId']) {
                    event['transId'] = batchId;
                }
                this.sendEvent(action, event, successCallback, failCallback);
            });
        },
        getDefaultTrackingParams(action) {
            const defaultParams = {};
            defaultParams['code'] = code;
            defaultParams['sid'] = sessionManager.getSessionId();
            defaultParams['uid'] = sessionManager.getUID();
            defaultParams['sdk'] = SDK;
            defaultParams['v'] = SDK_VERSION;
            defaultParams['ts'] = new Date().getTime();
            if (action) {
                defaultParams['action'] = action;
            }
            return defaultParams;
        },
    };
    return client;
}
